export const LOGO = "/logo.png";

export const IMG = {
  heroMic: "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  micPop: "https://images.unsplash.com/photo-1531651008558-ed1740375b39?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  console: "https://images.unsplash.com/photo-1618609377864-68609b857e90?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  micDark: "https://images.pexels.com/photos/10933688/pexels-photo-10933688.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  micWhite: "https://images.unsplash.com/photo-1660631228116-b3643559f611?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const AVATAR_BOY = "/avatar-boy.png";
export const AVATAR_GIRL = "/avatar-girl.png";

// Standard gender-based profile image (custom photo uploads were removed).
export const profileImage = (talent) => (talent?.gender === "female" ? AVATAR_GIRL : AVATAR_BOY);
